import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { UserDto, UserServiceProxy, RoleServiceProxy, RoleListDtoListResultDto, CreateUserDto } from '@shared/service-proxies/service-proxies';
import { AlertController, LoadingController, NavController } from '@ionic/angular';
import { AppStorageService } from '@shared/storage/app-storage.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-user',
  templateUrl: './user.page.html',
  styleUrls: ['./user.page.scss'],
})
export class UserPage implements OnInit {

  id: number;
  user: UserDto;
  formGroup : FormGroup;
  roles: RoleListDtoListResultDto;
  rolesOptions: string[];
  isLoaded: boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    private alertController: AlertController,
    storageService: AppStorageService,
    private route: ActivatedRoute,
    private router: Router,
    private loadingController: LoadingController,
    private userSvc: UserServiceProxy,
    private roleSvc: RoleServiceProxy,
    private titleService: Title,
    private navCtrl: NavController
  ) {
    storageService.IsLoadedSubject.subscribe(x => { 
      if (!this.isLoaded && x) {
        this.getRoles();
        this.route.queryParams.subscribe(params => {
          if (params && params.userId) {
            this.id = +params.userId;
            if (this.id > 0) {
              this.getUser();
            } else {
              this.initializeNewUser();
            }
          } else {
            this.initializeNewUser();
          }
          this.isLoaded = true;
        });
      }
    });
    this.titleService.setTitle('OACI - User Form');
    this.setupForm();
  }

  ngOnInit() {

  }

  ionViewWillEnter() {
    this.setupForm();
  }

  setupForm() {
    if (this.formGroup) {
      this.formGroup.reset();
    }
    this.formGroup = this.formBuilder.group({
      name: [''],
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      userName: [''],
      surname: [''],
      emailAddress: ['', Validators.required],
      fullName: [''],
      roleNames: [[]],
      isActive: [true, Validators.required]
    });
  }

  async getUser() {
    
    const loading = await this.loadingController.create({
      message: 'Fetching User...',
    });
    await loading.present();

    this.userSvc.get(this.id).subscribe(async user => {
      this.user = user;
      if (this.user) {
        this.loadUserFields();
        await loading.dismiss();
      }
    });
  }

  initializeNewUser() {
    this.id = null;
    this.user = new UserDto();
  }

  loadUserFields() {
    const user = this.user;
    this.formGroup.patchValue({
      name: user.name,
      firstName: user.firstName,
      lastName: user.lastName,
      userName: user.userName,
      surname: user.surname,
      emailAddress: user.emailAddress,
      fullName: user.fullName,
      roleNames: user.roleNames,
      isActive: user.isActive
    });
  }

  async submitForm() {
    if (this.formGroup.valid) {
      this.saveUser();
    } else {
      const alert = await this.alertController.create({
        header: 'Error',
        subHeader: 'Error',
        message: 'Missing Form Fields.',
        buttons: ['OK']
      });
  
      await alert.present();
    }
  }

  async saveUser() {
    
    const loading = await this.loadingController.create({
      message: 'Saving User...',
    });
    await loading.present();
    
    const saveUser = this.formGroup.getRawValue();
    const request = new CreateUserDto();
    const fullName = saveUser.firstName + ' ' + saveUser.lastName;
    request.emailAddress = saveUser.emailAddress;
    request.firstName = saveUser.firstName;
    request.lastName = saveUser.lastName;
    request.name = fullName;
    request.surname = fullName;
    request.fullName = fullName;
    request.userName = saveUser.emailAddress;
    request.isActive = true;
    request.roleNames = saveUser.roleNames;
    request.sendPasswordResetLink = true;
    request.sendConfirmationEmail = false;
    if (!this.id) {
      this.userSvc.create(request).subscribe(
        async userResponse => {
          this.id = userResponse.id;
          this.user = userResponse;
          await loading.dismiss();
          this.saveUserSuccess();
        },
        async error => {
          this.saveUserError(error).then();
          await loading.dismiss();
        }
      );
    } else {
      saveUser.id = this.id;
      saveUser.password = null;
      this.userSvc.update(saveUser).subscribe(
        async userResponse => {
          this.user = userResponse;
          await loading.dismiss();
        },
        async error => {
          this.saveUserError(error).then();
          await loading.dismiss();
        }
      );
    }
  }

  async saveUserSuccess() {
    const alert = await this.alertController.create({
      header: 'Success',
      message: 'User has been saved',
      buttons: ['OK']
    });

    await alert.present();
  }

  async saveUserError(errorMessage) {
    const alert = await this.alertController.create({
      header: 'Error',
      subHeader: 'Error',
      message: errorMessage,
      buttons: ['OK']
    });

    await alert.present();
  }

  cancel() {
    this.navCtrl.back();
    // this.router.navigate(['/main/home']);
  }

  getRoles() {
    this.roleSvc.getRoles('').subscribe(roles => {
      this.roles = roles;
      this.rolesOptions = this.roles.items.map(role => role.name);
    })
  }

}
